module.exports = __webpack_public_path__ + "img/AB66C82C.8580054c.png";